import { Box, Container, Grid, Stack, Typography } from '@mui/material';

import { gridSizeMdLg12, gridSizeMdLg8 } from '@/shared';
import { useIsMediaQuery } from '@/shared/hooks';
import { CreateOrCancelButtons } from '.';

export type TabsFormBoxSceneProps = {
  children: React.ReactNode;
  titlePage: string;
  titlePageNode?: React.ReactNode;

  /// save and cancel btn
  showBtns?: boolean;
  onCancel?: () => void;
  onSave?: (
    e?: React.BaseSyntheticEvent<object, any, any> | undefined
  ) => Promise<void>;
  cancelTextBtn?: string;
  saveTextBtn?: string;

  disableSubmitBtn?: boolean;

  ///* content
  content?: React.ReactNode;

  ///* tabs
  tabs: any;

  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };

  showCustomBtns?: boolean;
  customBtns?: React.ReactNode;

  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';

  pb?: number;
};

const TabsFormBoxScene: React.FC<TabsFormBoxSceneProps> = ({
  children,
  titlePage,
  titlePageNode,

  showBtns = true,
  onCancel,
  onSave,
  disableSubmitBtn = false,
  cancelTextBtn = 'Cancelar',
  saveTextBtn = 'Guardar',

  tabs,
  size = gridSizeMdLg8,

  showCustomBtns = false,
  customBtns,

  maxWidth = 'lg',
  content,
  pb = 1
}) => {
  const isMobile = useIsMediaQuery('sm');


  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        pb: 2
      }}
    >
      <Container maxWidth={maxWidth}>
        <Stack spacing={2}>
          {/* =========== title =========== */}
          {titlePageNode ?? <Typography variant="h4" pb={isMobile ? 3 : pb}>
            {titlePage}
          </Typography>}

          {content}

          {/* =========== form =========== */}
          <Grid item container alignContent={"center"} justifyContent={"center"}>
            <Grid  container justifyContent="center"{...size}>

              {/* ======== tabs ======= */}
              {tabs}

              {/* ======== tab panel ======= */}
              <Grid sx={{ maxWidth:"100%" }}>
                {children}
              </Grid>

              {/* ====== submit btn ====== */}
              {showBtns && onCancel && onSave && (
                <Grid item container {...gridSizeMdLg12}
                  sx={{
                    pr: 2,
                  }}
                >
                  <CreateOrCancelButtons
                    onCancel={onCancel}
                    onSave={onSave}
                    disabled={disableSubmitBtn}
                    cancelTextBtn={cancelTextBtn}
                    saveTextBtn={saveTextBtn}
                  />
                </Grid>
              )}
              {/* ====== custom btns ====== */}
              {showCustomBtns && customBtns}
            </Grid>
          </Grid>
        </Stack>
      </Container>
    </Box>
  );
};

export default TabsFormBoxScene;
